<template>
  <div class="change-user-info-wrap">
    <HModal
      :visible="visible"
      :show-close="false"
    >
      <div class="change-user-info">
        <div class="change-user-info-hd sprite-change-user-info sprite-change-user-info-bg">
          <div
            @click="close"
            class="close-btn"
          />
          <div class="logo">
            <i class="sprite-icon sprite-icon-home-logo" />PDF-个人资料
          </div>
          <div class="tabs">
            <div
              v-for="item in tabs"
              :key="item.id"
              :class="{active: item.id === active}"
              @click="clickTabs(item.id)"
              class="tab"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <template v-if="active === 1">
          <div class="change-user-info-bd">
            <div class="infos">
              <div class="avatar-wrap">
                <div
                  v-if="!avatar && !selectedAvatar"
                  class="sprite-icon sprite-icon-avatar"
                />
                <img
                  v-else
                  :src="selectedAvatar || avatar"
                  class="avatar"
                >
                <p class="title">
                  我的头像
                </p>
              </div>
              <div class="nickname">
                <span>我的昵称：</span>
                <div>
                  <p>{{ nickname }}</p>
                  <p
                    v-if="msg"
                    class="msg"
                  >
                    *{{ msg }}
                  </p>
                </div>
              </div>
              <div class="user_openid">
                <span class="account">账号ID：</span>
                <span>{{ openId }}</span>
                <span
                  @click="copyOpenId"
                  class="copy_openid"
                >复制</span>
              </div>
            </div>
            <div class="avatars-list">
              <p>个性头像库<em>（请在下方选择您喜欢的头像）</em></p>
              <div class="avatars">
                <div
                  v-for="(item, index) in avatarList"
                  :key="index"
                  @click="selectAvatar(index)"
                  class="avatar-item {active: index===active}"
                >
                  <img
                    v-if="item.url"
                    :src="item.url"
                    alt=""
                  >
                  <div
                    v-if="avatarId === item.id"
                    class="selected sprite-change-user-info sprite-change-user-info-select"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="change-user-info-ft">
            <div
              @click="changeUserInfo"
              class="btn"
            >
              保存
            </div>
          </div>
        </template>
        <template v-if="active === 2">
          <InvoiceEntrance />
        </template>
        <template v-if="active === 3">
          <RenewalOrder :continuousInfo="continuousInfo" />
        </template>
      </div>
    </HModal>
  </div>
</template>

<script>
import '@/assets/css/sprite-change-user-info.scss'
import { mapGetters, mapActions } from 'vuex'
import * as UserV2Api from '@/api/user'
import client from '@/client/'
import { extend } from '@zhfe/zhfe-util'
import { copyText } from '@/utils/util.js'
import RenewalOrder from './RenewalOrder.vue'
import { CONTINUOUS_STATUS } from './types'
import InvoiceEntrance from '../electronTicket/InvoiceEntrance.vue'

export default {
  components: {
    RenewalOrder,
    InvoiceEntrance
  },
  props: {
    /** 设置选中tab */
    tabActiveId: {
      type: Number,
      default: 0,
      validator: (value) => {
        return [0, 1, 2].indexOf(value) !== -1
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: 1,
      avatarId: '',
      avatarList: null,
      selectedAvatar: '',
      nickname: '',
      errorTips: {
        4909001: '昵称包含特殊字符',
        4909002: '昵称包含违禁词',
        4909003: '昵称长度超出限制'
      },
      msg: '',
      cnMaxLength: 8,
      enMaxLength: 16,
      maxLength: 16,
      oldName: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'openId', 'avatar', 'continuousInfo']),
    visible: {
      get () {
        this.updatedTabActive()
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    tabs () {
      if (this.continuousInfo.continuous_status === CONTINUOUS_STATUS.SIGNED) {
        return [
          { name: '资料修改', id: 1 },
          { name: '发票/订单', id: 2 },
          { name: '续费订单', id: 3 }
        ]
      }
      return [
        { name: '资料修改', id: 1 },
        { name: '发票/订单', id: 2 }
      ]
    }
  },

  created () {
    this.nickname = this.userInfo ? this.userInfo.nickname : ''
    this.oldName = this.userInfo ? this.userInfo.nickname : ''
    this.maxLength = this.nickname ? this.getStringLengthForChinese(this.nickname) : this.cnMaxLength
    this.avatarId = ''
    this.selectedAvatar = ''

    this.getAvatarList()
  },
  methods: {
    ...mapActions('user', ['refresh']),

    updatedTabActive () {
      if (this.value && this.tabActiveId) {
        this.clickTabs(this.tabActiveId)
      }
    },

    clickTabs (index) {
      this.active = index
    },
    async getAvatarList () {
      const res = await UserV2Api.getAvatarList()
      if (res && res.avatar_list) {
        this.avatarList = res.avatar_list
      }
    },
    selectAvatar (index) {
      const item = this.avatarList[index]
      this.avatarId = item.id
      this.selectedAvatar = item.url
    },
    /* eslint-disable-next-line */
    async changeUserInfo () {
      this.report({
        click: 1
      })

      if (!this.nickname.trim()) {
        this.msg = '请填写您的昵称'
        return
      }

      const hasChangeName = this.oldName !== this.nickname
      const hasChangeAvatar = !!this.avatarId

      if (!hasChangeName && !hasChangeAvatar) {
        return
      }

      const res = await UserV2Api.modifyUserInfo({
        avatar_id: this.avatarId,
        nickname: this.nickname
      })
      if (res && res.resp_common) {
        if (res.resp_common.ret === 0) {
          this.refresh({ token: this.token, open_id: this.openId, webRefresh: 1 })
          client.common.API.paySuccess({ token: this.token, open_id: this.openId })
          this.msg = ''
          this.$toast('修改成功！', { duration: 1500 })
          this.report({
            click: 2,
            /* eslint-disable-next-line */
            operation: hasChangeName && hasChangeAvatar ? 3 : (hasChangeName ? 1 : (hasChangeAvatar ? 2 : 0)),
            img_id: this.avatarId || 0
          })
          setTimeout(() => {
            this.close(true)
          }, 1500)
        } else if (this.errorTips[res.resp_common.ret]) {
          this.msg = this.errorTips[res.resp_common.ret]
        } else {
          this.$toast('服务端错误')
        }
      }
    },
    close (noReport) {
      this.$emit('close')
      this.visible = false
      !noReport && this.report({
        click: 2
      })
    },
    getStringLengthForChinese (str) {
      const strArr = str.split('')
      let bytesCount = 0
      strArr.forEach((val, index) => {
        if (!this.isChinese(str.charCodeAt(index))) { // 非中文
          bytesCount = bytesCount + 1
        } else {
          bytesCount = bytesCount + 2
        }
      })
      return bytesCount
    },
    inputChange () {
      setTimeout(() => {
        this.maxLength = this.computedLen(this.nickname, this.enMaxLength, this.cnMaxLength)
      }, 200)
    },
    computedLen (str, totalLength, maxLength) {
      const strArr = str.split('')
      const totalLen = totalLength // 总的输入长度
      let maxLen = maxLength // input或textarea上maxlength的值，这里由于中文算2个占位，所以传入的maxLength应该为totalLength的一半
      let len = 0 // 已经输入的字符数
      let leftLen = 0 // 剩余可输入字符数
      /* eslint-disable-next-line */
      strArr.forEach((val, index) => {
        if (!this.isChinese(str.charCodeAt(index))) {
          leftLen = Math.ceil(totalLen - len * 2) // 剩余输入数等于总长 - 输入数，乘以2是因为非中文的len只算0.5
          if (leftLen === 0) {
            return false // 如果剩余数是0,就退出循环，不能输入了
          }
          len = len + 0.5 // 如果输入非中文，算加半个字符，maxlengtrh也加0.5,这样就实现了两个非中文长度等于一个中文
          maxLen = maxLen + 0.5
        } else {
          len = len + 1
        }
      })
      return Math.ceil(maxLen)
    },
    isChinese (charCode) {
      return !((charCode > 0x0001 && charCode <= 0x007e) || (charCode >= 0xff60 && charCode <= 0xff9f))
    },
    report (params) {
      client.user.REPORT.reportChangeUserInfo(extend({
        openid: this.openId
      }, params))
    },

    copyOpenId () {
      copyText(this.openId, () => this.$toast('复制成功'))
    },
  }
}
</script>

<style lang="scss" scoped>
.change-user-info-wrap {
  * {
    box-sizing: border-box;
  }

  .change-user-info {
    width: 600px;
    height: 410px;
    background-color: #fff;
    .change-user-info-hd{
      position: relative;
      padding: 8px;
      .logo {
        display: flex;
        align-items: center;
        color: #b07400;
        font-size:12px;
        i {
          margin-right: 4px;
        }
      }
      .close-btn {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        right: 0;
        background-image: url(~@/assets/images/not-close.png);
        cursor: pointer;
        &:hover {
          background-position-x: center;
        }
        &:active {
          background-position-x: right;
        }
      }
      .tabs {
        position: absolute;
        left: 8px;
        bottom: 0;
        display: flex;
        align-items: center;
        .tab {
          width: 177px;
          height: 29px;
          margin-right: 2px;
          background-color: #FFEFAA;
          border-radius:2px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          font-size:12px;
          color: #b07400;
          text-align: center;
          line-height: 29px;
          cursor: pointer;
        }
        .active {
          background-color: #fff;
          color: #575757;
        }
      }
    }
    .change-user-info-bd {
      height: 230px;
      padding: 25px 44px 0;
      color: #575757;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      .infos {
        .avatar-wrap {
          width: 72px;
          margin: 24px 0 19px 96px;
          text-align: center;
        }
        .avatar {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          border:1px solid #D9D9D9;
        }
        .title {
          margin-top: 5px;
        }
        .nickname {
          display: flex;
          line-height: 32px;
          input {
            width: 166px;
            height: 32px;
            padding: 0 10px;
          }
          input::selection {
            background-color:#addafc;
          }
          .msg {
            color: #ff0000;
          }
        }
        .user_openid{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .account{
            width: 60px;
          }
          .copy_openid{
              display: inline-block;
              width: 36px;
              text-align: center;
              border: 1px solid #b07400;
              color: #b07400;
              box-sizing: border-box;
              margin-left: 3px;
              cursor: pointer;
          }
        }

      }
      .avatars-list {
        width: 245px;
        em {
          color: #b1b1b1;
          font-style: normal;
        }
        .avatars {
          height: 166px;
          margin-top: 10px;
          background-color: #F2F2F2;
          padding: 0 0 10px 1px;
          display: flex;
          flex-wrap: wrap;
          .avatar-item {
            position: relative;
            margin: 10px 0 0 10px;
            cursor: pointer;
            img {
              width: 68px;
              height: 68px;
              border-radius:2px;
            }
            .selected {
              position: absolute;
              top: -4px;
              left: -4px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .change-user-info-ft {
      margin-top: 32px;
      .btn {
        width:232px;
        height:38px;
        margin: 0 auto;
        background-color: #DC320A;
        color: #fff;
        font-size:12px;
        text-align: center;
        line-height: 38px;
        border-radius:19px;
        cursor: pointer;
        &:hover {
          background-color: #FF390B;
        }
        &:active {
          background-color: #C42C08;
        }
      }
    }
  }
}
</style>
